





































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Label from '@/components/common/elements/Label.vue';
import DatePicker from '@/components/common/elements/DatePicker.vue';

@Component({
  components: { Label, DatePicker }
})
export default class DatePickerArea extends Vue {
  // ラベルのname属性
  @Prop({ default: '' })
  private labelName!: string;
  // ラベル内テキスト
  @Prop({ default: '' })
  private labelText!: string;
  // 追加付与クラス
  @Prop({ default: '' })
  private labelClass?: string;
  // デートピッカーの要素
  @Prop({ default: '' })
  private name!: string;
  // 入力要素名（日本語）
  @Prop({ default: '' })
  private label?: string;
  // デートピッカーの初期値
  @Prop({ default: '' })
  private value?: string;
  // デートピッカーの表示タイプ初期値
  @Prop({ default: 'date' })
  private type?: string;
  // デートピッカーの表示形式
  @Prop({ default: '' })
  private format?: string;
  // 入力要素プレースホルダ
  @Prop({ default: '' })
  private placeholder?: string;
  // デートピッカーを入力可能か否か
  @Prop({ default: false })
  private isDisabled?: boolean;
  // デートピッカー内選択ボタン色 (参考：https://vuetifyjs.com/ja/styles/colors/#sass-)
  @Prop({ default: 'primary' })
  private sendTextColor?: string;
  // デートピッカー内の選択可能な過去日を指定
  @Prop({ default: '' })
  private minDate?: string;
  // デートピッカー内の選択可能な未来日を指定
  @Prop({ default: '' })
  private maxDate?: string;
  // 誕生日用ピッカーか否か
  @Prop({ default: false })
  private isBirthday?: boolean;
  // 入力クリア機能の使用可否
  @Prop({ default: false })
  private isClearable?: boolean;

  @Prop({ default: '' })
  private rules?: string;
  /**
   * 親コンポーネントに子コンポーネントの値を通知する
   * @module inputOperation
   * @param {[k: string]: string} data - input要素名と値
   * @return {[k: string]: string} data - input要素名と値
   */
  @Emit('inputOperation')
  public inputOperation( data:{[k: string]: string}) {
    data.type = 'datetime';
    return data;
  }
}
